import React, { useState, useEffect } from "react";

export default function BoggleAlgorithms() {
  const images = [`${process.env.PUBLIC_URL}/Boggle.png`];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div
      className="relative text-white flex flex-col items-center justify-center min-h-screen px-4 text-center"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/Boggle-BG.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay blur */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm z-0" />

      {/* Content Layout */}
      <div className="relative z-10 flex flex-col md:flex-row items-stretch w-full max-w-6xl px-8 pt-[27vh] gap-12 mb-20">
        {/* Left: Text Section */}
        <div className="w-full md:w-1/2 flex flex-col justify-center text-left space-y-6">
          <h1 className="text-xl md:text-5xl font-extrabold text-purple-400">
            Boggle Algorithms
          </h1>
          <p className="text-gray-200 text-base md:text-lg max-w-xl">
            Developed a highly optimized algorithm capable of finding over 68,000 valid words on a 16x16 Boggle board within one second.
          </p>
          <ul className="list-disc list-outside pl-6 text-gray-300 leading-relaxed text-base md:text-lg space-y-4">
            <li>Combined advanced indexing with DFS for optimal performance.</li>
            <li>Implemented in Rust, Haskell, and Elixir for runtime comparisons.</li>
            <li>Minimized search space and boosted speed significantly.</li>
          </ul>
          <a
            href="https://github.com/MithilPeeris/Boggle-Algorithms"
            target="_blank"
            rel="noopener noreferrer"
          >
            <button className="border border-purple-600 px-6 py-3 md:px-8 md:py-4 rounded-full font-semibold text-purple-600 hover:bg-purple-600 hover:text-white transition text-sm md:text-base">
              📄 See Code
            </button>
          </a>
        </div>

        {/* Right: Image Section */}
        <div className="w-full md:w-1/2 flex justify-center items-center">
          <img
            src={images[currentImage]}
            alt="Boggle"
            className="w-full h-full object-cover rounded-2xl shadow-lg"
          />
        </div>
      </div>
    </div>
  );
}